// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1PzpD","error":"Textarea_error__7RufZ","readonly":"Textarea_readonly__1g-E9","disabled":"Textarea_disabled__3-WDY"};